<template>
  <div id="tips-phone">
    <div class="titles center ">
      <h1 class="title-first merriweather-reg-20">{{ $t("Propositions.title1") }}</h1>
      <h1 class="title-second merriweather-reg-26">{{ $t("Propositions.title2") }}</h1>
    </div>
    <div class="pt-2 pt-5">
    <div class="tips-card" style="overflow: scroll; overflow-y: hidden">
        <div class="col-proposition">
          <div class="card-proposition" data-aos="fade-up" data-aos-duration="1000" @click="handleClick('/reservation-hotel')">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/LUXE+RESPONSABLE%2C+SE%CC%81LECTION+D'EXCEPTION+Des+lieux+d'exception.jpg" v-set-alt >
            <div class="image-overlay-proposition"></div>
            <div class="card-proposition-content text-center">
              <p class="element raleway-bold-p16">Luxe responsable, sélection d'exception</p>
              <p class="sub-element raleway-reg-p15">Des lieux d’exception, évalués via notre Green Note, alliant confort et durabilité</p>
            </div>            
          </div>
        </div>

        <div class="col-proposition">          
          <div class="card-proposition" data-aos="fade-up" data-aos-duration="1000" @click="handleClick('/programme-fidélité-hortensia')">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/CLUB+HORTENSE_+PRIVILE%CC%80GES+EXCLUSIFS.jpg" v-set-alt >
            <div class="image-overlay-proposition"></div>
            <div class="card-proposition-content text-center">
              <p class="element raleway-bold-p16">Club Hortense : privilèges exclusifs</p>
              <p class="sub-element raleway-reg-p15">Avantages uniques, offres spéciales et services premium réservés à nos membres</p>
            </div>
          </div>
        </div>
<!-- 
      <div class="col-proposition">
        <div class="card-proposition" data-aos="fade-up" data-aos-duration="1000">
          <img src="../images/proposition/proposition-7.png" v-set-alt >
          <p class="element raleway-bold-p pb-3">{{ $t("Propositions.content.seven") }}</p>
          <a href="/club-hortense" class="anchor">{{ $t("Propositions.anchor.seven") }}</a>
        </div>
      </div> -->

<!--      <div class="col-proposition">-->
<!--        <div class="card-proposition" data-aos="fade-up" data-aos-duration="1000">-->
<!--          <img src="../images/proposition/sixith.jpeg" v-set-alt >-->
<!--          <p class="element raleway-bold-p">Des journées et séjours bien-être</p>-->
<!--          <a href="/experiences-bien-etre" class="anchor">Découvrez nos expériences bien-être</a>-->
<!--        </div>-->
<!--      </div>-->

      <div class="col-proposition">
        <div class="card-proposition" data-aos="fade-up" data-aos-duration="1000" @click="handleClick('/les-nouveautes-hortense')">
          <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/AUCUN+FRAIS%2C+VOYAGE+SEREIN+ET+LE%CC%81GER.jpg" v-set-alt >
          <div class="image-overlay-proposition"></div>
          <div class="card-proposition-content text-center">
            <p class="element raleway-bold-p16">Aucun frais, voyage serein et léger</p>
            <p class="sub-element raleway-reg-p15">0 frais de réservation et des transactions 100 % sécurisées pour une tranquillité totale.</p>
          </div>
        </div>
      </div>

        <div class="col-proposition">          
          <div class="card-proposition" data-aos="fade-up" data-aos-duration="1000" @click="handleClick('/voyage-sur-mesure')">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EXPERIENCES+AUTHENTIQUES+ET+LOCALES.jpg" v-set-alt >
            <div class="image-overlay-proposition"></div>
            <div class="card-proposition-content text-center">
              <p class="element raleway-bold-p16">Expériences authentiques et locales</p>
              <p class="sub-element raleway-reg-p15">Carnets d’adresses et guides de voyage exclusifs, pour des découvertes uniques.</p>
            </div>
          </div>
        </div>

        <div class="col-proposition">          
          <div class="card-proposition" data-aos="fade-up" data-aos-duration="1000" @click="handleClick('/programme-evergreen-demarche-environnementale')">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/EVERGREEN.+L'ENGAGEMENT+DURABLE.jpg" v-set-alt >
            <div class="image-overlay-proposition"></div>
            <div class="card-proposition-content text-center">
              <p class="element raleway-bold-p16">Evergreen, l’engagement durable</p>
              <p class="sub-element raleway-reg-p15">Une empreinte carbone réduite tout en soutenant des projets écoresponsables.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AOS from 'aos';

  export default {
    name: 'propositions',
    data() {
      return {
        cssProps: {
          backgroundImage: `url(${require('../images/icotype.svg')})`
        }
      }
    },
    methods: {
      handleClick(url) {
        window.open(url, '_blank');
      }
    },
    mounted() {
      AOS.init();
    },
    computed: {
      isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      }else{
        return false;
      }
     }
    },
  }
</script>


<style lang="scss" scope='app/assets/stylesheets/components/tips'>

</style>
<style lang="scss" scoped>
  .desktop-margin {
    margin-top: 1rem !important;
  }
  .center{
    text-align: center;
  }
  .anchor{
        text-decoration: underline;
        font-family: $Raleway;
        font-weight: 500;
        font-size: 15px;
        color: #000000;
  }
  .subtitle{
    width: 670px;
  }
  .element{
    width: 100%;
  }
  .card-proposition{
    img{
      width: 240px;
      height: 404px;
      object-fit: cover;
      border-radius: 15px;
    }

    .card-proposition-content {
      position: absolute;
      bottom: 1rem;
      left: 0;
      right: 0;
      text-align: center;
      color: white;
      font-size: 1.2rem;
      font-weight: bold;
      text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
      padding: 102px 16px 24px 16px;
    }
  }

  .title-first {
    padding-top: 70px !important;
  }

  .tips-card {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    grid-gap: 27px;
  }

  #tips-phone {
    padding-left: 18px;
    padding-right: 18px;
  }
  .image-overlay-proposition {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 0;
    pointer-events: none;
    border-radius: 15px;
  }
  .card-proposition {
    border-radius: 15px;
  }
</style>
